import { VideoHelpModalComponent } from '../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/video-help-modal.component';
import { VideoOutput } from '../../team-apis/otterdam/outputs/video-output';
import { OutputHelper } from './output-helper';

export class VideoOutputHelper extends OutputHelper<VideoOutput> {
  override isMultiFrameOutput = true;

  override getHelpModalType(_output: VideoOutput) {
    return VideoHelpModalComponent;
  }

  override isOrthographicProjection(output: VideoOutput) {
    return output.meta.is_orthographic_projection;
  }
}
